import layzyload from 'layzyload';

window.addEventListener('DOMContentLoaded', function(){
	init();
});
const init = () =>{
	organizeProducts();
	//setLazy();
}
const organizeProducts = () =>{
	const allImg=document.querySelectorAll(".prdImage img");
	allImg.forEach((o)=>{
		o.onload=function(e){
			const ldr=e.target.closest(".image").querySelector(".loaderWrap");
			if(ldr){
				ldr.remove();
			}
		}
	});
	lazyload(document.querySelectorAll(".prdImage img"));
}

